import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanDeactivate, RouterStateSnapshot, UrlTree } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { Observable } from 'rxjs';

import { AppStoreFacadeService } from '../../../../facades/app-store-facade.service';

export interface CanComponentDeactivate {
  canDeactivate: () => Observable<boolean> | Promise<boolean> | boolean;
}

@Injectable()
export class CanDeactivateGuard implements CanDeactivate<CanComponentDeactivate> {

  constructor(
    private appStoreFacadeService: AppStoreFacadeService,
    private translateService: TranslateService) {}

  canDeactivate(component: CanComponentDeactivate,
                currentRoute: ActivatedRouteSnapshot,
                currentState: RouterStateSnapshot,
                nextState?: RouterStateSnapshot
  ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    const componentCanDeactivate = component.canDeactivate ? component.canDeactivate() : true;


    if (!componentCanDeactivate) {
      return new Promise<boolean>((resolve) => {
        this.appStoreFacadeService.errors.openConfirmModal(
          this.translateService.instant('MODALS.ERROR.DIRTY_FORM'),
          resolve
        );
      });
    }


    return componentCanDeactivate;
  }
}
